import clientHttp, { prefixBase } from '../../clientHttp';
import ResourceHttp from '../../resourceHttp';

class OrgaoResourceHttp extends ResourceHttp {
  constructor(http, resource) {
    super();
    this.http = http;
    this.resource = resource;
  }

  getOrgaosInstituicoes(instituicoes) {
    return this.http.post(`${this.resource}/list/instituicao`, { instituicoes });
  }

  listOrgaosUsuario() {
    return this.http.get(`${this.resource}/list/usuario`);
  }
}

const resource = 'orgao';

const pessoaHttp = new OrgaoResourceHttp(clientHttp, prefixBase + resource);

export default pessoaHttp;
